import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Instagram = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 48 49"
      fill={'none'}
      {...rest}
    >
      <path
        d="M8 16.5859C8 14.4642 8.84285 12.4294 10.3431 10.9291C11.8434 9.42879 13.8783 8.58594 16 8.58594H32C34.1217 8.58594 36.1566 9.42879 37.6569 10.9291C39.1571 12.4294 40 14.4642 40 16.5859V32.5859C40 34.7077 39.1571 36.7425 37.6569 38.2428C36.1566 39.7431 34.1217 40.5859 32 40.5859H16C13.8783 40.5859 11.8434 39.7431 10.3431 38.2428C8.84285 36.7425 8 34.7077 8 32.5859V16.5859Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 24.5859C18 26.1772 18.6321 27.7034 19.7574 28.8286C20.8826 29.9538 22.4087 30.5859 24 30.5859C25.5913 30.5859 27.1174 29.9538 28.2426 28.8286C29.3679 27.7034 30 26.1772 30 24.5859C30 22.9946 29.3679 21.4685 28.2426 20.3433C27.1174 19.2181 25.5913 18.5859 24 18.5859C22.4087 18.5859 20.8826 19.2181 19.7574 20.3433C18.6321 21.4685 18 22.9946 18 24.5859Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33 15.5859V15.6059"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Instagram.displayName = 'Instagram';
